import moment from "moment";
import { date, object } from "yup";

export namespace Between {
  export interface T {
    start: Date;
    end: Date;
  }
  export const schema = object({
    start: date()
      .required()
      .min(new Date(), "Date must be in the future")
      .label("Start date"),
    end: date()
      .required()
      .test(
        "invalid-date",
        "End date must be after start date",
        (value, context) =>
          value === undefined ||
          context.parent.start === undefined ||
          moment(context.parent.start).isBefore(moment(value))
      )
      .label("End date"),
  }).required();
}
